/**
 * Validadores puros do chat de pós-graduação — mesmas regras do
 * `ModalBankSlip` (nome, e-mail, telefone) e do fluxo de captação da
 * Atalia (validação por passo, com mensagem de erro reaproveitada como
 * fala do atendente).
 */

import { isCompletePhone, normalizePhone } from './phone'

export type ValidationResult =
  | { readonly ok: true; readonly value: string }
  | { readonly ok: false; readonly message: string }

export type Validator = (input: string) => ValidationResult

export const VALIDATION_MESSAGES = {
  name: 'Poderia me informar seu nome?',
  email:
    'Esse e-mail parece estar incompleto. Poderia conferir e enviar novamente?',
  phone: 'Poderia informar o número completo, incluindo o DDD?',
} as const

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/

function requireText(input: string, message: string): ValidationResult {
  const value = input.trim()
  if (value.length === 0) {
    return { ok: false, message }
  }
  return { ok: true, value }
}

export function validateName(input: string): ValidationResult {
  return requireText(input, VALIDATION_MESSAGES.name)
}

export function validateEmail(input: string): ValidationResult {
  const value = input.trim()
  if (!EMAIL_PATTERN.test(value)) {
    return { ok: false, message: VALIDATION_MESSAGES.email }
  }
  return { ok: true, value }
}

/** Valor devolvido já normalizado: dígitos com `55`, sem `+` (T1 do fluxo). */
export function validatePhone(input: string): ValidationResult {
  if (!isCompletePhone(input)) {
    return { ok: false, message: VALIDATION_MESSAGES.phone }
  }
  return { ok: true, value: normalizePhone(input) }
}

/** Passos de opção: a resposta precisa ser um dos `values` oferecidos. */
export function createOptionValidator(
  values: readonly string[],
  message: string
): Validator {
  return (input: string): ValidationResult => {
    const value = input.trim()
    if (!values.includes(value)) {
      return { ok: false, message }
    }
    return { ok: true, value }
  }
}
